<button
  mat-stroked-button
  color="primary"
  type="button"
  [disabled]="isDisabled()"
  (click)="linkMicrosoftAccount()"
>
  @if (isLinking()) {
    Linking Microsoft...
  } @else {
    {{ buttonText() }}
  }
</button>
